import {Slide, Typography} from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';

export const useRefreshSpinnerStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      alignItems: 'center',
      background: 'rgba(14, 25, 65, 0.7)',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      zIndex: theme.zIndex.drawer + 1,
    },
    spinnerLabel: {
      color: 'rgb(255, 255, 255)',
      // fontFamily: '"Allstate Sans", Arial, Helvetica, sans-serif',
      fontFamily: '"Roboto", sans-serif',
      fontSize: '1.5rem',
      fontWeight: 500,
      letterSpacing: '-0.0125rem',
      lineHeight: '2.25rem',
      textAlign: 'center',
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.7rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '2rem',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '2rem',
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '2.75rem',
      },
    },
    spinner: {
      color: 'rgb(69, 188, 229)',
      marginTop: '2rem',
    },
    sisenseSpinner: {
      color: 'rgb(69, 188, 229)',
      marginTop: '8rem',
      position: 'absolute', left: '50%', top: '50%',
      transform: 'translate(-50%, -50%)'
    },
  })
);

export default function RefreshSpinner() {
  const {isOpen, spinnerLabel} = useSelector((state: ReducerState) => state.refreshToken);
  const classes = useRefreshSpinnerStyles();

  return (
    <Backdrop
      className={classes.backdrop}
      open={isOpen}
      timeout={{enter: 400, exit: 400}}
      style={{transitionDelay: `${isOpen ? '0' : '300'}ms`}}
      transitionDuration={400}
    >
      <Slide
        in={isOpen}
        timeout={{enter: 400, exit: 400}}
        style={{transitionDelay: `${isOpen ? '0' : '300'}ms`}}
        direction="up"
        mountOnEnter
        unmountOnExit
      >
        <Typography variant="h3" className={classes.spinnerLabel}>
          {spinnerLabel !== undefined ? spinnerLabel : 'Refreshing Application'}
        </Typography>
      </Slide>
      <Fade
        in={isOpen}
        timeout={{enter: 400, exit: 400}}
        style={{transitionDelay: `${isOpen ? '200' : '300'}ms`}}
        mountOnEnter
        unmountOnExit
      >
        <CircularProgress className={classes.spinner} />
      </Fade>
    </Backdrop>
  );
}
